export enum Permission {
  USERS_EDIT = 'USERS_EDIT',
  ORDERS_VIEW = 'ORDERS_VIEW',
  CANCEL_ORDER = 'CANCEL_ORDER',
  ORDER_DETAILS_EDIT = 'ORDER_DETAILS_EDIT',
  CANCEL_RETURN = 'CANCEL_RETURN',
  RELEASE_RETURN = 'RELEASE_RETURN'
}
